import React from "react";
import { connect } from "react-redux";
import { Table, Tab } from "semantic-ui-react";
import _ from "lodash";
import Property from "../reports/Property/Property";
import ResultHeader from "./ResultHeader";
import PropertyRecordHeader from "./PropertyRecordHeader";
import "../../assets/styles/sub-table.css";
import { getMenuItem } from "../common/PageHelper";

class PropertyResult extends React.Component {
  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
  }

  render() {
    const results = [];
    let recCount = 0;
    let tabHeader;
    if (
      this.props.searchResultData !== undefined ||
      this.props.searchResultData !== null
    ) {
      const propData = _.get(
        this.props.searchResultData,
        "propertys.propertyRecords[0].records[0].property"
      );
      const orderedPropNodes = _.orderBy(
        propData,
        (e) => [
          parseInt(
            _.get(e, "record[0].deed[0].recordingDate[0].year[0]._", 1),
            10
          ),
          parseInt(_.get(e, "parcelId[0]", 1), 10),
        ],
        ["desc", "asc"]
      );
      const acctType = _.get(
        this.props.searchResultData,
        `${Object.keys(this.props.searchResultData)[0]}.log[0].actType[0]`,
        ""
      );

      const showNarrowSearchMessage =
        propData &&
        propData.length > 25 &&
        (acctType.indexOf("Person") !== -1 ||
          acctType.indexOf("People") !== -1) &&
        acctType.indexOf("Enhanced") === -1;
      tabHeader = (
        <ResultHeader
          showNarrowSearchMessage={showNarrowSearchMessage}
          {...this.props}
        />
      );
      const properties = [];
      const parcelIds = [];
      _.forEach(orderedPropNodes, (property) => {
        const parcelId = _.trim(_.get(property, "parcelId[0]"));
        if (_.findIndex(parcelIds, (pid) => pid === parcelId) === -1) {
          properties.push(property);
          parcelIds.push(parcelId);
        }
      });
      const parCount = _.countBy(orderedPropNodes, (p) =>
        _.trim(_.get(p, "parcelId[0]"))
      );
      const basicPropReport =
        this.props.additionalData &&
        _.filter(
          this.props.reports,
          (a) => a.ReportID === this.props.additionalData.reportIds[0]
        );
      const compPropReport =
        this.props.additionalData &&
        _.filter(
          this.props.reports,
          (a) => a.ReportID === this.props.additionalData.reportIds[1]
        );
      _.forEach(properties, (property, propIndex) => {
        const parcelId = _.trim(_.get(property, "parcelId[0]"));
        results.push(
          <Table className="table-no-padding" key={`Property_Rec_${propIndex}`}>
            <Table.Body>
              <PropertyRecordHeader
                parcelId={parcelId}
                propIndex={propIndex}
                propRecCount={parCount[parcelId]}
                node={property}
                key={`Res_Property_Rec_Header_${propIndex}`}
                {...this.props}
                basicReportPrice={
                  basicPropReport &&
                  basicPropReport.length > 0 &&
                  basicPropReport[0].SearchResultCost
                }
                compReportPrice={
                  compPropReport &&
                  compPropReport.length > 0 &&
                  compPropReport[0].SearchResultCost
                }
              />
              <Table.Row key={`Property_Row_${propIndex}`}>
                <Table.Cell colSpan={2}>
                  <Property
                    key={`Res_Property_Table_${propIndex}`}
                    node={_.get(property, "record[0]")}
                    index={propIndex}
                    {...this.props}
                  />
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        );
        recCount += 1;
      });
    }
    const tabs = [];
    const { userAccount } = this.props;
    tabs.push({
      menuItem: getMenuItem(
        userAccount.acctTheme,
        true,
        `${recCount} Matches Found`
      ),
      render: () => (
        <Tab.Pane>
          {tabHeader}
          {results.length > 0 && (
            <Table stackable className="table-no-border">
              <Table.Body>
                <Table.Row>
                  <Table.Cell>{results}</Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          )}
        </Tab.Pane>
      ),
    });
    return <Tab panes={tabs} />;
  }
}

function mapStateToProps(state) {
  return {
    reports: state.uiData.Reports,
    userAccount: state.userAccount,
  };
}

export default connect(mapStateToProps, null)(PropertyResult);



// WEBPACK FOOTER //
// ./src/components/searchresults/PropertyResult.js